module.exports = __webpack_public_path__ + "static/pill-bottle-93c16a281c33dd0e22092e689a5ca078.png";